module.exports.easing = {
  linear: p12303 => p12303,
  easeInQuad: p12304 => p12304 * p12304,
  easeOutQuad: p12305 => p12305 * (2 - p12305),
  easeInOutQuad: p12306 => p12306 < 0.5 ? p12306 * 2 * p12306 : -1 + (4 - p12306 * 2) * p12306,
  easeInCubic: p12307 => p12307 * p12307 * p12307,
  easeOutCubic: p12308 => --p12308 * p12308 * p12308 + 1,
  easeInOutCubic: p12309 => p12309 < 0.5 ? p12309 * 4 * p12309 * p12309 : (p12309 - 1) * (p12309 * 2 - 2) * (p12309 * 2 - 2) + 1,
  easeInQuart: p12310 => p12310 * p12310 * p12310 * p12310,
  easeOutQuart: p12311 => 1 - --p12311 * p12311 * p12311 * p12311,
  easeInOutQuart: p12312 => p12312 < 0.5 ? p12312 * 8 * p12312 * p12312 * p12312 : 1 - --p12312 * 8 * p12312 * p12312 * p12312,
  easeInQuint: p12313 => p12313 * p12313 * p12313 * p12313 * p12313,
  easeOutQuint: p12314 => 1 + --p12314 * p12314 * p12314 * p12314 * p12314,
  easeInOutQuint: p12315 => p12315 < 0.5 ? p12315 * 16 * p12315 * p12315 * p12315 * p12315 : 1 + --p12315 * 16 * p12315 * p12315 * p12315 * p12315
};